import { useEffect, useState } from 'react'
import { RecipientsWidget } from '@/components/settings/recipients-widget'
import { getRecipients, setRecipients } from '@/api/settings'
import { AWS_ACCOUNTS } from '@/lib/types'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Label } from '@/components/ui/label'

export function SettingsPage() {
  const [accountId, setAccountId] = useState(AWS_ACCOUNTS[0]?.id ?? '')
  const [recipients, setRecipientsState] = useState<string[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!accountId) return
    setLoading(true)
    setError(null)
    getRecipients(accountId)
      .then(setRecipientsState)
      .catch((e: Error) => setError(e.message))
      .finally(() => setLoading(false))
  }, [accountId])

  const handleSaveRecipients = async (updated: string[]): Promise<void> => {
    await setRecipients(accountId, updated)
    setRecipientsState(updated)
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Settings</h1>
        <p className="text-muted-foreground">Manage global configuration for SES domain management</p>
      </div>

      <div className="max-w-2xl space-y-6">
        <div className="space-y-2">
          <Label htmlFor="account-select">AWS Account</Label>
          <Select value={accountId} onValueChange={(v) => v && setAccountId(v)}>
            <SelectTrigger id="account-select" className="w-64">
              <SelectValue placeholder="Select account" />
            </SelectTrigger>
            <SelectContent>
              {AWS_ACCOUNTS.map((a) => (
                <SelectItem key={a.id} value={a.id}>
                  {a.alias} ({a.id})
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {error && <p className="text-sm text-destructive">{error}</p>}

        {!loading && (
          <RecipientsWidget
            key={accountId}
            initialRecipients={recipients}
            onSave={handleSaveRecipients}
          />
        )}
      </div>
    </div>
  )
}
